module.exports = __webpack_public_path__ + "static/media/SmallCompetitor.0766614e.svg";